export default __webpack_public_path__ + "static/media/mobile-alt.429ea2ca.svg";